import React from "react";
import TagInfo from "../../components/TagInfo/TagInfo";
import { fancyDateFormat } from "../../utils/dates";

interface NewsTagInfoProps {
  className?: string;
  article: { date: string };
}

const NewsTagInfo = ({ className, article: { date } }: NewsTagInfoProps) => (
  <TagInfo
    value={[[<span key="date">{fancyDateFormat(date)}</span>]]}
    className={className}
  />
);

export default NewsTagInfo;
